// @ts-nocheck
import type * as Types from '../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResendReceiptMutationVariables = Types.Exact<{
  input: Types.ResendReceiptInput;
}>;


export type ResendReceiptMutation = { __typename?: 'Mutation', resendReceipt: { __typename?: 'BankAccountTransaction', id: string, receiptSent?: number | null } | { __typename?: 'CardTransaction', id: string, receiptSent?: number | null } | { __typename?: 'ChariotTransaction', id: string, receiptSent?: number | null } | { __typename?: 'OfflineTransaction', id: string, receiptSent?: number | null } };


export const ResendReceiptDocument = /*#__PURE__*/ gql`
    mutation ResendReceipt($input: ResendReceiptInput!) {
  resendReceipt(input: $input) {
    id
    receiptSent
  }
}
    `;

/**
 * __useResendReceiptMutation__
 *
 * To run a mutation, you first call `useResendReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendReceiptMutation, { data, loading, error }] = useResendReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendReceiptMutation(baseOptions?: Apollo.MutationHookOptions<ResendReceiptMutation, ResendReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendReceiptMutation, ResendReceiptMutationVariables>(ResendReceiptDocument, options);
      }
export type ResendReceiptMutationHookResult = ReturnType<typeof useResendReceiptMutation>;